// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"52efdb3c","732":"f36201e5"}[chunkId] + ".chunk.js";
};